import React, { Component } from 'react'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import outroeu from '../../assets/music/outroeu.mp3'
import allstar from '../../assets/music/allstar.mp3'
import flor from '../../assets/music/flor.mp3'
import paraquedas from '../../assets/music/paraquedas.mp3'
import maneva from '../../assets/music/maneva.mp3'

const playlist = [
    { name: 'outroeu', src: outroeu },
    { name: 'allstar', src: allstar },
    { name: 'flor', src: flor },
    { name: 'paraquedas', src: paraquedas },
    { name: 'maneva', src: maneva },
  ]
  
  class Player extends Component {
    state = {
      currentMusicIndex: 0,
    }
  
    handleClickPrevious = () => {
      this.setState((prevState) => ({
        currentMusicIndex: prevState.currentMusicIndex === 0 ? playlist.length - 1 : prevState.currentMusicIndex - 1,
      }))
    }
  
    handleClickNext = () => {
      this.setState((prevState) => ({
        currentMusicIndex: prevState.currentMusicIndex < playlist.length - 1 ? prevState.currentMusicIndex + 1 : 0,
      }))
    }
  
    render() {
      const { currentMusicIndex } = this.state
      return (
        <div>
          <AudioPlayer
            autoPlay
            customVolumeControls={[]}
            customAdditionalControls={[]}
            style={{width: '110px'}}
            autoPlayAfterSrcChange={true}
            showSkipControls={true}
            showJumpControls={false}
            src={playlist[currentMusicIndex].src}
            onClickPrevious={this.handleClickPrevious}
            onClickNext={this.handleClickNext}
            customProgressBarSection={[]}
          />
        </div>
      )
    }
  }
  
  export default Player